import './styles/NoOffer.scss';

import { Grid, Paper } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

export default function NoOffer() {
  const { t } = useTranslation();
  return (
    <Grid container className="no-offer" component={Paper}>
      {t(translations.pages.myJobOffers.noOffers())}
    </Grid>
  );
}
